export const actiontypes = {
  MESSAGE:  'MESSAGE',
  LOADING:  'LOADING'
}

export const actions = {
  message: (message = null, variant = 'information', loading = null) => {
    return {
      type: actiontypes.MESSAGE,
      message,
      variant,
      loading
    }
  },
  loading: (loading = true) => {
    return {
      type: actiontypes.LOADING,
      loading
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/io/index.js